<template>
    <div>
		<v-dialog
			v-model="dialog"
			persistent
			fullscreen
			transition="slide-x-reverse-transition"
		>
            <v-card flat>
                <!-- title -->
                <v-toolbar dark flat color="primary" class="text-uppercase">
                    <v-spacer/>
                    {{title}}
                    <v-spacer/>
                    <v-toolbar-items text>
                        <v-btn small text @click="dialog=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                
                <v-form @submit.prevent="submit" ref="form">
                    <!-- card content -->
                    <v-card-text class="py-0">
                        <v-container>
                            <v-row dense>
								<v-col v-if="id === null && customersTypes.length" cols="12" align-self="center">
									<v-chip-group
										v-model="dirType"
										show-arrows
										center-active
										active-class="success"
										class="d-flex justify-center pt-0"
										mandatory
										@change="reset"
									>
										<v-chip 
											v-for="(type, index) in customersTypes"
											:key="index"
											:value="type.id"
											class="rounded-xl"
										>
											{{ type.name }}
										</v-chip>
									</v-chip-group>
								</v-col>
                                <!-- pricing types -->

                                <v-col v-if="visitConfigByCustomerType?.VisitPriceType" md="6" cols="12">
									{{$T('inputs.pricing-types')}}
									<v-radio-group
										v-model="priceTypeId"
										mandatory
										row
										hide-details
										class="pt-0 my-2"
										@change="updateSamplesPrices"
									>
										<v-radio
											v-for="priceType in priceTypes"
											:key="priceType.id"
											:label="priceType.name"
											:value="priceType.id"
											class="mx-auto"
											color="success"
										/>
									</v-radio-group>
                                </v-col>

                                <!-- date -->
                                <v-col cols="12">
									<v-menu
										v-model="visitDateMenu"
										:close-on-content-click="false"
										offset-y
									>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="visitDate"
												:label="$T('inputs.date')"
												hide-details="auto"
												dense
												:disabled="Boolean(id)"
												readonly
												:rules="rules.date"
												v-bind="attrs"
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker
											v-model="visitDate"
											:disabled="Boolean(id)"
											:min="moment().format('YYYY-MM-DD')"
											:max="moment().format('YYYY-MM-DD')"
											@input="visitDateMenu = false"
											@change="getHoliday()"
										></v-date-picker>
									</v-menu>
                                </v-col>
								<!-- region -->
                                <v-col md="6" cols="12">
									<v-autocomplete
										v-model="regionId"
										:items="regions"
										item-text="name"
										item-value="id"
										:label="$T('inputs.region')"
										hide-details
										@change="fetchEntities"
										clearable
									></v-autocomplete>
                                </v-col>

                                <!-- entity -->
                                <v-col md="6" cols="12" class="d-flex align-end">
									<v-autocomplete
										v-model="entityId"
										:items="allEntities"
										item-text="name"
										item-value="id"
										hide-details
										:search-input.sync="entitySearchInput"
										:label="$T('inputs.customer-name')"
										:loading="EntitiesLoading"
										:disabled="EntitiesLoading"
										:rules="rules.required"
										@change="updateItemsFromSpecialtyMaterials"
										v-on="{
											focus: () =>
												allEntities.length && 
												!allEntities[allEntities.length - 1].id ? allEntities.splice(-1, 1) : null,
											blur: () =>
												allEntities.push({ id: null, name: entitySearchInput }),
										}"
										clearable
									>
										<template
											v-if="showEntityAddressInMenus"
											v-slot:item="{ attrs, on, item }"
										>
											<v-list-item
												v-show="item.id"
												v-on="item.id ? on : {}"
												v-bind="item.id ? attrs : {}"
											>
												<v-list-item-content class="py-0">
													<v-list-item-title class="mb-0">
														{{item.name}}
													</v-list-item-title>
													<v-list-item-subtitle
														v-if="
															Array.isArray(item.entityAddresses) &&
															item.entityAddresses?.length
														"
													>
														<v-icon size="16">mdi-map-marker</v-icon>
														<span class="text-subtitle-2">
															{{
																item.entityAddresses
																	.map(address => address.address).join(', ')
															}}
														</span>
													</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</template>
									</v-autocomplete>
									
									<v-btn
										v-if="addingCustomerDirectly"
										icon
										:disabled="EntitiesLoading || regionId === null"
										class="ms-2"
										@click="
											$emit('add-customer', {
												name: entitySearchInput,
												regionId: regionId
											})
										"
									>
										<v-icon>mdi-account-plus</v-icon>
									</v-btn>
                                </v-col>

								<!-- persons -->
								<!-- v-if="dirType === 0 || dirType === 2" -->
								<v-col v-if="visitConfigByCustomerType?.EmployeeDealtWith">
									<div class="d-flex flex-grow-1 justify-space-between align-center">
                                        <div class="d-flex align-center">
                                            <v-icon class="me-2">mdi-account</v-icon>
                                            <span class="text-body-1">{{$T('inputs.persons')}}</span>
                                        </div>

                                        <v-btn
											text
											@click="personsNames.push({
												id: personsNames.length,
												name: null,
											})"
                                        >
                                            <v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
                                        </v-btn>
                                    </div>
									
									<v-card v-if="personsNames.length > 0" class="my-2">
                                        <v-card-text>
                                            <v-row
												v-for="(person, index) in personsNames"
												:key="person.id"
												dense
												class="align-center"
                                            >
                                                <!-- sample -->
                                                <v-col cols="10">
													<v-text-field
														v-model="person.name"
														:placeholder="$T('inputs.name')"
														dense
														hide-details="auto"
														:rules="!id ? rules.required : []"
													></v-text-field>
                                                </v-col>

                                                <v-col cols="2" class="pa-0">
													<v-btn
														text
														small
														@click="
															personsNames.forEach((c, i) => {
																if (i > index) personsNames[i].id--;
															})
															personsNames.splice(index, 1);
														"
													>
                                                        <v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
								</v-col>

                                <!-- samples -->
                                <v-col cols="12">
                                    <div class="d-flex flex-grow-1 justify-space-between align-center">
                                        <div class="d-flex align-center">
                                            <v-icon class="me-2">mdi-pill</v-icon>
                                            <span class="text-body-1">{{$T('inputs.samples')}}</span>
                                        </div>

										<v-spacer/>

										<!-- restore planed materials specialty -->
										<v-btn
											v-if="
												useMaterialsSpecialtyVisits &&
												isFilledPlanedSamplesFilled &&
												isSamplesPlanedChanged
											"
											icon
											color="grey darken-3"
											@click="updateItemsFromSpecialtyMaterials"
										>
											<v-icon>mdi-restore</v-icon>
										</v-btn>

										<!-- add sample -->
                                        <v-btn text @click="addSample">
                                            <v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
                                        </v-btn>
                                    </div>
                                    
                                    <!-- sample card -->
                                    <v-card v-if="samples.length > 0">
                                        <v-card-text class="px-4 py-2">
											<v-row
												v-for="sample in samples"
												:key="sample.id"
												dense
												class="align-center"
											>
                                                <!-- sample -->
                                                <v-col cols="7">
													<v-autocomplete
														v-model="sample.data.materialId"
														:items="materials"
														:item-text="getFullMaterialName"
														item-value="id"
														:placeholder="$T('inputs.sample')"
														dense
														hide-details
														:rules="rules.required"
														@change="id => {
															sample.data.price =
																!sample.data.isFree
																	? getMaterialPrice(sample.data.materialId)
																	: 0;
															isSamplesPlanedChanged = true;
														}"
													></v-autocomplete>
                                                </v-col>

                                                <!-- amount -->
                                                <!-- <v-col :cols="samples.length > 1 ? 3 : 5"> -->
												<v-col :cols="3">
													<v-text-field
														v-model.number="sample.data.amount"
														:placeholder="$T('inputs.amount')"
														type="number"
														min="0"
														dense
														hide-spin-buttons
														hide-details
														:rules="[...rules.number, val => val > 0]"
														@change="isSamplesPlanedChanged = true;"
													></v-text-field>
                                                </v-col>
												<!-- use price because price not found in configuration yet! -->
												<template v-if="usePrices">
													<!-- price -->
													<v-col :cols="3" class="pt-2">
														<v-text-field
															v-model.number="sample.data.price"
															:label="$T('inputs.price')"
															type="number"
															min="0"
															dense
															disabled
															hide-spin-buttons
															hide-details
														></v-text-field>
													</v-col>
													
													<!-- discount -->
													<v-col :cols="3" class="pt-2">
														<v-text-field
															v-model.number="sample.data.discount"
															:label="$T('inputs.discount')"
															type="number"
															min="0"
															dense
															hide-spin-buttons
															hide-details
															suffix="%"
															:rules="[
																val => checkMaterialDiscountLimit(sample.data.materialId, val)
															]"
														></v-text-field>
													</v-col>
													
													<!-- isFree -->
													<!-- visitsConfig?.FreeSample -->
													<v-col v-if="visitConfigByCustomerType?.FreeSample" :cols="3" class="pt-2">
														<v-checkbox
															v-model.number="sample.data.isFree"
															:label="$T('inputs.free')"
															dense
															hide-details
															@change="val => {
																sample.data.price =
																	!val
																		? getMaterialPrice(sample.data.materialId)
																		: 0;
															}"
														></v-checkbox>
													</v-col>
												</template>

                                                <!-- remove button -->
                                                <v-col cols="2" class="pa-0">
													<v-btn text small @click="removeSample(sample.id)">
                                                        <v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
                                                    </v-btn>
                                                </v-col>

												<v-col cols="12" class="py-2">
													<v-divider/>
												</v-col>
                                            </v-row>

											<p v-if="usePrices" class="mb-0">
												<span class="text-body-2 me-2">{{$T('Visits.total')}}:</span>
												<span class="font-weight-bold">{{total}}</span>
											</p>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <!-- unavailable materialIds -->
								<!-- dirType === 2 -->
                                <v-col md="6" cols="12" v-if="customersTypes.find(c => c.id === dirType)?.name === 'Pharmacies'">
									<v-autocomplete
										v-model="unavailableMaterialIds"
										:items="allMaterials"
										:item-text="getFullMaterialName"
										item-value="id"
										:label="$T('inputs.unavailable-products')"
										dense
										multiple
										hide-details="auto"
										prepend-icon="mdi-close"
										class="mt-1"
									>
                                        <template v-slot:selection="{ item, index }">
                                            <span v-if="index === 0" class="me-1">{{ getFullMaterialName(item) }}</span>
                                            <span
                                                v-if="index === 1"
                                                class="grey--text text-caption"
                                            >
                                                (+{{ unavailableMaterialIds.length - 1 }} others)
                                            </span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>

                                <!-- competitors -->
								<!--  -->
								<!-- v-if="customersTypes.find(c => c.id === dirType)?.name === 'Pharmacies'"  -->
                                <v-col v-if="visitConfigByCustomerType?.CompetetiveSample" md="6" cols="12">
                                    <div class="d-flex flex-grow-1 justify-space-between align-center">
                                        <div class="d-flex align-center">
                                            <v-icon class="me-2">mdi-trending-up</v-icon>
                                            <span class="text-body-1">{{$T('inputs.competitors')}}</span>
                                        </div>

                                        <v-btn text @click="addCompetitor">
                                            <v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
                                        </v-btn>
                                    </div>

                                    <!-- Competitor card -->
                                    <v-card v-if="competitors.length > 0" class="my-2">
                                        <v-card-text>
                                            <v-row
												v-for="competitor in competitors"
												:key="competitor.id"
												dense
												class="align-center"
                                            >
                                                <!-- competitor -->
                                                <v-col cols="10">
													<v-text-field
														v-model="competitor.value"
														:placeholder="$T('inputs.competitor')"
														dense
														hide-details
														required
													></v-text-field>
                                                </v-col>

                                                <!-- remove button -->
                                                <v-col cols="2" class="pa-0">
                                                    <v-btn
                                                    text
                                                    small
                                                    @click="removeCompetitor(competitor.id)"
                                                    >
                                                        <v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

								<!-- coreMessage -->
                                <v-col md="6" cols="12">
									<v-text-field
										v-model="coreMessage"
										:label="$T('inputs.core-message')"
										prepend-icon="mdi-note-outline"
										hide-details
									></v-text-field>
                                </v-col>

								<!-- durationInMinutes -->
                                <v-col v-if="visitConfigByCustomerType?.DurationInMinute" md="6" cols="12">
									<v-text-field
										v-model.number="durationInMinutes"
										:label="$T('inputs.duration-minutes')"
										type="number"
										hide-spin-buttons
										:suffix="$T('inputs.minutes')"
										min="0"
										prepend-icon="mdi-clock-outline"
										hide-details
									></v-text-field>
                                </v-col>

                                <!-- other materials -->
                                <v-col v-if="configIsEmpty(visitsConfig) === false ? visitsConfig?.OtherMaterial : true" md="6" cols="12">
									<v-text-field
										v-model="otherSamples"
										:label="$T('inputs.other-materials')"
										prepend-icon="mdi-plus-minus-box"
										hide-details
									></v-text-field>
                                </v-col>

                                <!-- visitNotes -->
                                <v-col v-if="configIsEmpty(visitsConfig) === false ? visitsConfig?.VisitNotes : true" md="6" cols="12">
									<v-text-field
										v-model="visitNotes"
										:label="$T('inputs.visit-notes')"
										prepend-icon="mdi-note-multiple-outline"
										hide-details
									></v-text-field>
                                </v-col>

                                <!-- objection -->
                                <v-col v-if="configIsEmpty(visitsConfig) === false ? visitsConfig?.Objection : true" md="6" cols="12">
									<v-text-field
										v-model="objection"
										:label="$T('inputs.objection')"
										prepend-icon="mdi-alert-circle-outline"
										hide-details
									></v-text-field>
                                </v-col>

                                <!-- nextCall -->
                                <v-col v-if="configIsEmpty(visitsConfig) === false ? visitsConfig?.NextVisitNotes : true" md="6" cols="12">
									<v-text-field
										v-model="nextCall"
										:label="$T('inputs.next-call')"
										prepend-icon="mdi-check"
										hide-details
									></v-text-field>
                                </v-col>

                                <!-- center notes -->
								<!--  v-if="dirType === 2" -->
                                <v-col md="6" cols="12">
									<v-text-field
										v-model="centerNotes"
										:label="$T('inputs.notes')"
										prepend-icon="mdi-note-multiple-outline"
										hide-details
									></v-text-field>
								</v-col>

								<!-- payment method -->
								<!-- visitsConfig?.PaymentType -->
								<v-col v-if="visitConfigByCustomerType?.PaymentType" md="6" cols="12">
									{{$T('inputs.payment-type')}}
									<v-radio-group
										v-model="paymentMethodId"
										mandatory
										row
										hide-details
										class="pt-0 mt-2"
									>
										<v-radio
											v-for="item in paymentMethods"
											:key="item.id"
											:label="item.name"
											:value="item.id"
											class="mx-auto"
											color="success"
										/>
									</v-radio-group>
								</v-col>

								<!-- paid amount  -->
								<!-- && visitsConfig?.AmountReceived -->
								<v-col
									v-if="paymentMethodId === paymentMethod.debit && visitConfigByCustomerType?.AmountReceived"
									md="6"
									cols="12"
									class="d-flex align-center"
								>
									<span class="text-body-2 me-4">{{$T('inputs.paid-amount')}}</span>
									<v-text-field
										v-model.number="paidAmount"
										type="number"
										hide-details
										hide-spin-buttons
										dense
										:rules="rules.number"
									/>
								</v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" text type="submit" :loading="loading" :disabled="loading">
                            {{$T('save')}}
                        </v-btn>
                        <v-btn color="grey darken-1" text @click="dialog = false">
                            {{$T('close')}}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import rules from '@/helpers/validation rules'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import { addingCustomerDirectly, showEntityAddressInMenus, useMaterialsSpecialtyVisits, usePrices, deletionExternal, enableVacations } from '@/configs/general.configs'
import { paymentMethod } from '@/helpers/enums'
import { getDateColor } from '@/helpers/functions'
export default {
	data() {
		return {
			// configs
			paymentMethod,
			usePrices,
			showEntityAddressInMenus,
			addingCustomerDirectly,
			useMaterialsSpecialtyVisits,
			deletionExternal,

			// helpers
			id: null,
			dialog: false,

			title: null,

			loading: false,
			EntitiesLoading: false,
			rules,
            
			sampleCounter: 1,
			competitorCounter: 0,

			visitDateMenu: false,
			moment,

			oldVisitPaymentAmount: null,
			
			isFilledPlanedSamplesFilled: false,
			isSamplesPlanedChanged: false,
			
			// check availability
			isTyping: false,
			entitySearchInput: null,
			allEntities: [],

			// data
			dirType: null,
			priceTypeId: null,
			visitDate: null,
			regionId: null,
			entityId: null,
			personsNames: [],
			// samples: [{ id: 1, data: { materialId: null, amount: null } }],
			samples: [],
			coreMessage: null,
			durationInMinutes: null,
			otherSamples: null,
			visitNotes: null,
			objection: null,
			nextCall: null,
			unavailableMaterialIds: [],
			competitors: [],
			centerNotes: null,
			paymentMethodId: null,
			paidAmount: null,
			enableVacations
		}
	},

	watch: {
		dialog(val) {
			if (val && !this.customersTypes.length) {
				this.$store.dispatch('entities/fetchEntityType');
			} if (val && !this.id) {
				this.fetchEntities()
			}
		}
	},

	methods: {
		reset() {
			if (this.$refs.form) this.$refs.form.resetValidation();

			this.id = null;
			this.priceTypeId = null;
			this.sampleCounter = 1;
			this.competitorCounter = null;

			this.regionId = null;
			this.entityId = null;
			// this.samples = [{ id: 1, data: { materialId: null, amount: null } }];
			this.personsNames = [];
			this.samples = [];
			this.coreMessage = null;
			this.durationInMinutes = null;
			this.otherSamples = null;
			this.visitNotes = null;
			this.objection = null;
			this.nextCall = null;
			this.unavailableMaterialIds = [];
			this.competitors = [];
			this.centerNotes = null;
		},

		// samples
		addSample() {
			this.samples.push({
				id: ++this.sampleCounter,
				data: {
					materialId: null,
					amount: null,
					price: null,
					discount: null,
					isFree: false
				}
			});

			if (
				useMaterialsSpecialtyVisits &&
				this.isFilledPlanedSamplesFilled
			) {
				this.isSamplesPlanedChanged = true
			}
		},

		removeSample(id) {
			const index = this.samples.findIndex(c => c.id === id);
			this.samples.splice(index, 1);
			this.samples.forEach(sample => {
				if (sample.id > index) {
					sample.id--;
				}
			})
			this.sampleCounter--;

			if (
				useMaterialsSpecialtyVisits &&
				this.isFilledPlanedSamplesFilled
			) {
				this.isSamplesPlanedChanged = true
			}
		},

		updateSamplesPrices() {
			for (let i = 0; i < this.samples.length; i++) {
				this.samples[i].data.price =
					this.samples[i].data.isFree ? 0 : this.getMaterialPrice(this.samples[i].data.materialId);
			}
		},

		getMaterialPrice(materialId) {
			if (!materialId) return 0;
			const material = this.getMaterialById(materialId);
			const priceObj = (material.prices || []).find(c => c.priceId === this.priceTypeId);

			return (priceObj && priceObj.active ? priceObj.price || material.price : material.price) || 0;
		},

		checkMaterialDiscountLimit(materialId, materialDiscount) {			
			if (!materialId || !materialDiscount) return true;
			const material = this.getMaterialById(materialId);
			const priceObj = (material.prices || []).find(c => c.priceId === this.priceTypeId);
			const limitDiscount = priceObj && priceObj.active ? priceObj.priceDiscount : null;
			return !limitDiscount || (materialDiscount > 0 && materialDiscount <= limitDiscount); 
		},
        
		// competitor
		addCompetitor() {
			this.competitors.push({
				id: this.competitorCounter++,
				value: null
			})
		},

		removeCompetitor(index) {
			this.competitors.splice(index, 1);
			this.competitors.forEach(competitor => {
				if (competitor.id > index) {
					competitor.id--;
				}
			})
			this.competitorCounter--;
		},

		// find data
		getFullMaterialName(material) {
			const details = [
				this.getMaterialFormById(material.materialFormId).name,
				material.dose,
				material.strength
			];

			return `${material.name} (${details.filter(c => c != null).join(' ')})`;
		},

		fetchEntities() {
			this.EntitiesLoading = true;

			this.$store.dispatch('entities/fetchAll', { entityType: this.dirType, regionId: this.regionId })
				.then(() => {
					this.allEntities = Array.from(this.entities);
				})
				.finally(() => {
					this.EntitiesLoading = false;
				})
		},

		updateItemsFromSpecialtyMaterials() {
			this.isFilledPlanedSamplesFilled = false;
			this.isSamplesPlanedChanged = false
			this.samples = [];
			let materials = [];
			const entity = this.allEntities.find(c => c.id === this.entityId);
			if (
				!useMaterialsSpecialtyVisits ||
				!this.specialtyMaterials.length ||
				!entity ||
				!entity.entityAddresses?.length
			) return;
			
			const specialtyMaterial =
				this.specialtyMaterials.find(c => c.specialtyId === entity.specialtyIds[0]);
			const address = entity.entityAddresses[0];
			
			if (!specialtyMaterial) return;
			const workload = specialtyMaterial.workloads.find(c => c.workloadId === address.workloadId);
			
			if (workload) {
				materials = workload.materials;
			} else {
				materials = specialtyMaterial.materials;
			};
			
			if (materials.length) {
				this.isFilledPlanedSamplesFilled = true;
				materials.forEach((c) => {
					this.samples.push({
						id: ++this.sampleCounter,
						data: {
							materialId: c.materialId,
							amount: c.amount,
							price: null,
							discount: null,
							isFree: false
						}
					})
				})
			}
		},

		// dialog functions
		addVisit(type, date) {
			this.reset();
			this.dirType = type;
			this.title = this.$t('Visits.add-visit');
			this.visitDate = moment().diff(date, 'days') <= 1 ? date : moment().format('YYYY-MM-DD');
			this.dialog = true;
		},

		editVisit(id) {
			this.reset();
			this.id = id;
			this.fillData();
			this.title = this.$t('Visits.edit-visit');
			this.dialog = true;
		},

		fillData() {
			const visit = this.getVisitById(this.id);
			this.dirType = visit.entity.entityTypeId;

			this.visitDate = moment(visit.createdAt).format('YYYY-MM-DD');
			this.regionId = visit.entityAddresses[0].regionId;
			this.entityId = visit.entity.id;
			this.coreMessage = visit.coreMessage;
			this.durationInMinutes = visit.durationInMinutes;
			this.otherSamples = visit.otherSamples;
			this.visitNotes = visit.notes;
			this.objection = visit.objections;
			this.nextCall = visit.purpose;
			this.centerNotes = visit.nextVisitNotes;
			this.personsNames =
				visit.residentDoctorNames?.split(',').map((c, i) => ({ id: i, name: c.trim() })) || [];
            
			visit.unavailableMaterials.forEach(materialName => {
				this.unavailableMaterialIds.push(this.getMaterialByName(materialName).id);
			})

			this.samples = [];
			visit.materialAmounts.forEach(material => {
				this.samples.push({
					id: ++this.sampleCounter,
					data: {
						materialId: material.materialId,
						amount: material.amount,
						price: usePrices ? (!material.freeSample ? material.sellPrice : 0) : null,
						discount: usePrices ? material.priceDiscount : null,
						// isFree: this.visitsConfig?.FreeSample ? material.freeSample : null,
						isFree: material.freeSample ? material.freeSample : null
					}
				})
			});

			if (visit.competitiveSamples.length > 0) {
				visit.competitiveSamples.forEach(sample => {
					this.competitors.push({
						id: this.competitorCounter++,
						value: null
					})
				});
			} else {
				this.competitors = []
			}
			
			if (usePrices) {
				this.paymentMethodId = visit.payment;
				this.paidAmount = visit.amountReceived;
				this.oldVisitPaymentAmount = this.total;
			}
			
			this.fetchEntities();
		},

		submit() {
			if (this.$refs.form.validate()) {
				this.loading = true;

				// grouping duplicated records
				const samples = this.samples.map(({ data }) => ({
					materialId: data.materialId,
					amount: data.amount,
					...(
						usePrices
							? {
								sellPrice: data.price,
								freeSample: data.isFree,
								priceDiscount: data.discount
							}
							: {}
					)
				})).reduce((res, a) => {
					const index = res.findIndex(c => a.materialId === c.materialId);
					if (index === -1) res.push(a);
					else res[index].amount += a.amount;
					return res;
				}, [])

				// create visit
				if (!this.id) {
					this.$store.dispatch('visits/create', {
						entityId: this.entityId,
						coreMessage: this.coreMessage,
						durationInMinutes: this.durationInMinutes,
						otherSamples: this.otherSamples,
						notes: this.visitNotes,
						objections: this.objection,
						nextVisitNotes: this.centerNotes,
						purpose: this.nextCall,
						materialAmounts: samples,
						unavailableMaterialIds: this.unavailableMaterialIds,
						competitiveSamples: this.competitors.map(c => c.value),
						residentDoctorNames: this.personsNames.map(c => c.name).join(', '),
						createdAt: this.visitDate,
						payment: this.paymentMethodId,
						amountReceived: this.paidAmount
					})
						.then(() => {
							this.$eventBus.$emit('show-snackbar', this.$t('Visits.visit-is-created'));
							this.$emit('on-save');
							this.dialog = false;
							if (usePrices) {
								this.$emit(
									'update-balance',
									this.paymentMethodId === paymentMethod.debit
										? this.paidAmount
										: this.total,
									this.oldVisitPaymentAmount
								);
								this.oldVisitPaymentAmount = null;
							}
						})
						.finally(() => {
							this.loading = false;
						})
				} else {
					// edit visit
					this.$store.dispatch('visits/update', {
						id: this.id,
						entityId: this.entityId,
						coreMessage: this.coreMessage,
						durationInMinutes: this.durationInMinutes,
						otherSamples: this.otherSamples,
						notes: this.visitNotes,
						objections: this.objection,
						nextVisitNotes: this.centerNotes,
						purpose: this.nextCall,
						materialAmounts: samples,
						unavailableMaterialIds: this.unavailableMaterialIds,
						competitiveSamples: this.competitors.map(c => c.value),
						residentDoctorNames: this.personsNames.map(c => c.name).join(', '),
						payment: this.paymentMethodId,
						amountReceived: this.paidAmount
					})
						.then(() => {
							this.$eventBus.$emit('show-snackbar', this.$t('Visits.visit-is-updated'));
							this.$emit('on-save');
							this.dialog = false;
							if (usePrices) {
								this.$emit(
									'update-balance',
									this.paymentMethodId === paymentMethod.debit
										? this.paidAmount
										: this.total,
									this.oldVisitPaymentAmount
								);
								this.oldVisitPaymentAmount = null;
							}
						})
						.finally(() => {
							this.loading = false;
						})
				}
			}
		},

		getHoliday () {
			const vacationDayDetails = this.vacationsDayDetails
			this.isHoliday = getDateColor(this.visitDate, this.vacations, { enableVacations, vacationDayDetails })
		},

		configIsEmpty (obj) {
			return obj ? Object.keys(obj).length === 0 : true
		}
	},

	computed: {
		...mapState({
			balance: state => state.profile.balance,
			regions: state => state.regions.regions,
			priceTypes: state => state.priceTypes.priceTypes,
			allMaterials: state => state.materials.materials,
			transactions: state => state.materialsTransactions.transactions,
			materialForms: state => state.materialForms.materialForms,
			entities: state => state.entities.entities,
			specialtyMaterials: (state) => state.materials.specialtyMaterials,
			customersTypes: state => deletionExternal ? state.entities.customersTypes.filter(c => c.name !== 'Externals') : state.entities.customersTypes,
			vacationsDayDetails: state => state.vacations.vacationsDayDetails,
			vacations: state => state.vacations.vacations,
			// configurations
			visitsConfig: state => state.configurations.configurations?.visitsConfig,
			// visit by customer
			visitsConfigByCustomerType: state => state.configurations.visitsConfigByCustomerType
		}),

		...mapGetters({
			getVisitById: 'visits/getVisitById',
			getMaterialById: 'materials/getMaterialById',
			getMaterialByName: 'materials/getMaterialByName',
			getMaterialFormById: 'materialForms/getMaterialFormById'
		}),

		materials() {
			const availableMaterials = [];
			const availableMaterialsIds = this.transactions.map(c => c.materialId);
			availableMaterialsIds.forEach(id => availableMaterials.push(this.getMaterialById(id)));
			return availableMaterials;
		},

		total() {
			return this.samples.map(c => c.data).reduce((res, c) => {
				const priceNet = c.amount * c.price;
				return res + (priceNet - (c.discount / 100) * priceNet);
			}, 0);
		},

		paymentMethods() {
			return [
				{ id: paymentMethod.cash, name: this.$T('payment-method.cash') },
				{ id: paymentMethod.credit, name: this.$T('payment-method.credit') },
				{ id: paymentMethod.debit, name: this.$T('payment-method.debit') },
			]
		},

		visitConfigByCustomerType () {
			return (this.customersTypes.length && this.customersTypes.length > 0) 
				? this.visitsConfigByCustomerType.find(c => c.key === this.dirType)?.data 
				: {}
		},
	},

	mounted() {
		if (!this.customersTypes.length) {
			this.$store.dispatch('entities/fetchEntityType');
		}
	}
}
</script>

<style>

</style>